'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _searchBar = require('@bibliocommons/search-bar');

var _searchBar2 = _interopRequireDefault(_searchBar);

var _sharedProgressBar = require('@bibliocommons/shared-progress-bar');

var _sharedProgressBar2 = _interopRequireDefault(_sharedProgressBar);

var _baseTabs = require('@bibliocommons/base-tabs');

require('../styles/AddTitle.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddTitle = function (_BcReactComponent) {
  _inherits(AddTitle, _BcReactComponent);

  function AddTitle() {
    _classCallCheck(this, AddTitle);

    return _possibleConstructorReturn(this, (AddTitle.__proto__ || Object.getPrototypeOf(AddTitle)).apply(this, arguments));
  }

  _createClass(AddTitle, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.onUpdateHandle) {
        this.props.onUpdateHandle();
      }
    }
  }, {
    key: 'renderTabContent',
    value: function renderTabContent(options, id, eventkey) {
      if (options === undefined) {
        return null;
      }

      var handleSearch = options.handleSearch,
          handleClear = options.handleClear,
          handleQueryChange = options.handleQueryChange,
          renderResults = options.renderResults,
          searchLabel = options.searchLabel,
          tabName = options.tabName,
          query = options.query;


      return _react2.default.createElement(
        _baseTabs.TabContent,
        {
          eventKey: eventkey,
          key: id,
          tabHref: id,
          label: tabName,
          testId: 'add-' + id },
        _react2.default.createElement(_searchBar2.default, {
          query: query,
          label: searchLabel,
          handleSearch: handleSearch,
          handleClear: handleClear,
          handleChange: handleQueryChange,
          isWrappedInForm: this.props.isWrappedInForm === undefined ? true : this.props.isWrappedInForm }),
        this.renderProgressBar(),
        renderResults()
      );
    }
  }, {
    key: 'renderProgressBar',
    value: function renderProgressBar() {
      return _react2.default.createElement(
        'div',
        { className: 'progress-bar-wrapper' },
        _react2.default.createElement(_sharedProgressBar2.default, { active: this.props.searching })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          catalogueOptions = _props.catalogueOptions,
          webOptions = _props.webOptions;

      return _react2.default.createElement(
        'section',
        { className: 'cp-add-title' },
        _react2.default.createElement(
          _baseTabs.Tabs,
          { defaultActiveKey: '0' },
          this.renderTabContent(catalogueOptions, 'catalog-item-tab', 0),
          this.renderTabContent(webOptions, 'web-item-tab', 1)
        )
      );
    }
  }]);

  return AddTitle;
}(_baseBcReactComponent2.default);

var tabOptionsShape = _react.PropTypes.shape({
  tabName: _react.PropTypes.string.isRequired,
  searchLabel: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.element]),
  handleSearch: _react.PropTypes.func.isRequired,
  handleClear: _react.PropTypes.func,
  handleQueryChange: _react.PropTypes.func,
  renderResults: _react.PropTypes.func
});

AddTitle.propTypes = {
  catalogueOptions: tabOptionsShape,
  webOptions: tabOptionsShape,
  searching: _react.PropTypes.bool,
  onUpdateHandle: _react.PropTypes.func,
  isWrappedInForm: _react.PropTypes.bool
};

exports.default = AddTitle;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/add-title/lib/components/add-title/components/AddTitle.component.js
// module id = 973
// module chunks = 1